<template>
	<div class="user">
		<div class="search">
			<span class="title">用户管理</span>
			<div class="flex">
				<div class="condition">
					<el-date-picker
								@change="timeChange"
					      v-model="date"
					      type="daterange"
								value-format="yyyy-MM-dd"
					      range-separator="至"
					      start-placeholder="开始日期"
					      end-placeholder="结束日期">
					</el-date-picker>
				</div>
				<div class="condition">
					 <el-input placeholder="请输入关键字" v-model="searchForm.key">
					    <el-select v-model="searchForm.keywordType" slot="prepend" placeholder="请选择" style="width: 110px;">
					      <el-option label="用户名" value="1"></el-option>
					      <el-option label="电话" value="2"></el-option>
					    </el-select>
					  </el-input>
				</div>
				<el-button type="success" @click="getList">搜 索</el-button>
				<el-button type="success" @click="designCompanyDialog = true">新增设计公司</el-button>
				<div class="flex margin-left">
					<el-upload
						class="upload-demo"
						accept=".xls,.xlsx"
						:action="action"
						:limit="1"
						:on-change="(file) => {handleChange(file)}"
						:show-file-list="false"
						:file-list="excelData"
						:headers="headers"
						:on-success="success"
						:on-erroe="error"
					>
						<el-button  type="success">EXCEL批量导入</el-button>
					</el-upload>
					<el-button  type="success" style="margin-left:10px" @click="downLoad">下载导入模板</el-button>
				</div>
			</div>
			
		</div>
		<div class="table">
			<el-table :data="tableData"  v-loading="loading" element-loading-text="数据加载中..." height="700px" align="center" :header-cell-style="{background:'#f4f7fe'}">
				<el-table-column prop="UserName" label="用户名"></el-table-column>
				<el-table-column prop="Phone" label="电话号码"></el-table-column>
				<el-table-column prop="UserType" label="用户类型"></el-table-column>
				<el-table-column prop="LastLoginTime" label="最后登录时间"></el-table-column>
				<el-table-column label="操作" align="right">
					<template slot-scope="scope">
						<el-button @click="rowDetail(scope.row)" type="success" size="small">详情</el-button>
						<el-button @click="deleteRowData(scope.row)" type="success" size="small">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="page">
			<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page.sync="currentPage"
				:page-sizes="[10, 20, 50]"
				layout="sizes, prev, pager, next"
				:total="total"
			></el-pagination>
		</div>

		<!-- 详情 -->
		<Dialog :form="form" :isDialogVisible="dialogVisible" @dialog-Confirm="dialogVisible = $event" />
		<!-- 设计公司弹窗 -->
		<el-dialog
			:title="designCompanyDialogType == 'add' ? '新增设计公司' : '设计公司详情'"
			:visible.sync="designCompanyDialog"
			width="450px"
			:before-close="handleClose">
			<el-form class="margin-top-sm" ref="designCompanyFrom" :model="designCompanyFrom" label-width="140px" :rules="rules">
				<el-form-item label="公司名称" prop="companyName">
					<el-input v-model="designCompanyFrom.companyName"></el-input>
				</el-form-item>
				<el-form-item label="手机号码" prop="phone">
					<el-input v-model="designCompanyFrom.phone"></el-input>
				</el-form-item>
				<el-form-item label="地址" prop="address">
					<el-input v-model="designCompanyFrom.address"></el-input>
				</el-form-item>
				<el-form-item label="统一社会信用代码" prop="contactsIdCard">
					<el-input v-model="designCompanyFrom.contactsIdCard"></el-input>
				</el-form-item>
				<div class="text-xs" style="margin-left:140px">*账号为联系电话，初始密码为电话后六位</div>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="success" @click="addDesignCompany" :loading="loading">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { GetUserList, GetDetailsByYHMX, AddCompany,DeleteUser } from '../../api/user.js';
import Dialog from './components/userDetail.vue';
import { baseUrl2 } from '@/static/utils/lyconfig';
import {DownFiles} from '@/api/file'

export default {
	name: 'user',
	components: {
		Dialog
	},
	data() {
		return {
			searchForm:{
				keywordType:'1',
				key:'',
				startTime:'',
				endTime:''
			},
			date:'',
			loading: false, // 数据是否处于加载状态
			tableData: [], // 表格数据
			form: {
				Fac: [],
				Fell: [],
				User: {}
			}, //详情信息
			total: 100, // 数据总数
			currentPage: 1, // 当前页数
			pageSize: 10, // 当前查询数据个数
			dialogVisible: false, // 对话框是否显示
			designCompanyDialog: false,  //设计公司弹窗
			designCompanyFrom: {
				companyName:'',//公司名称
				phone: '', //手机号码
				address: '', //地址
				contactsIdCard: '', //统一社会信用代码
			}, //设计公司表单
			designCompanyDialogType: 'add',  //设计公司弹窗
			headers:{"token":JSON.parse(localStorage.getItem("user-token"))},
			rules: {
				companyName:[{ required: true, message: '请填写公司名称', trigger: 'blur' }],
				phone:[{ required: true, message: '请填写手机号码', trigger: 'blur' }],
				address:[{ required: true, message: '请填写地址', trigger: 'blur' }],
				contactsIdCard:[{ required: true, message: '请填统一社会信用代码', trigger: 'blur' }]
			},
			excelData:[],
			action:baseUrl2 + '/api/User/UploadCompanyExcel'
		};
	},
	computed: {
		user() {
			return this.$store.state.user;
		}
	},
	mounted() {
		this.getList();
	},
	methods: {
		// 下载导入模板
		downLoad(){
			const that = this
			that.loading = true
			let params = {
				type:1,
				token:JSON.parse(localStorage.getItem("user-token")),
				isWorker:JSON.parse(localStorage.getItem("isWorker"))==true?'1':'2'
			}
			DownFiles(params).then(res=>{
					let blob = new Blob([res.data], { type: "application/vnd.ms-excel" }) // response就是接口返回的文件流
					let objectUrl = URL.createObjectURL(blob)
					const link = document.createElement("a")  // 创建a标签
					link.href = objectUrl
					link.download = "设计公司模板.xlsx"  // 自定义文件名
					link.click() // 下载文件
					URL.revokeObjectURL(objectUrl)  // 释放内存
					that.loading = false
			})
		},
		// excel上传成功回调
		success(response, file, fileList){
			if(response.state==1){
				this.$message.success(response.msg)
				this.excelData = []
				this.getList()
			}else{
				this.$message.error(response.msg)
			}
			
		},
		// excel上传失败回调
		error(){
			this.excelData = []
			this.$message.error('上传失败')
		},
		handleChange(file){
			var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1)
			const extension1 = testmsg === "xls";
			const extension2 = testmsg === "xlsx";
			if (!extension1 && !extension2) {
			  return this.$message.warning("请上传xls或xlsx类型文件!")
			}
		},
		// 选择时间
		timeChange(e){
			if(e){
				this.searchForm.startTime = e[0]
				this.searchForm.endTime = e[1]
			}else{
				this.searchForm.startTime = ''
				this.searchForm.endTime = ''
			}
		},
		// 分页查询
		handleSizeChange(e) {
			this.pageSize = e;
			this.getList();
		},
		handleCurrentChange(e) {
			this.currentPage = e;
			this.getList();
		},
		/*获取所有数据列表 */
		async getList() {
			this.loading = true
			try {
				let params = {
					pageNumber: this.currentPage,
					pageSize: this.pageSize,
					keyword: this.searchForm.key,
					keywordType:this.searchForm.keywordType,
					startTime:this.searchForm.startTime,
					endTime:this.searchForm.endTime
				};
				let { data } = await GetUserList(params);
				if (data.state === 1) {
					data = JSON.parse(data.data);
					this.tableData = data.Lis;
					this.total = data.Count;
					this.loading = false
				} else {
					this.loading = false
					this.$message.error(data.msg);
				}
			} catch (err) {
				// this.$message.error("获取采伐证列表列表失败,请稍后重试!");
			}
		},

		/* 数据详情 */
		rowDetail(row) {
			let params = {
				userCode: row.UserCode,
				isFac: row.IsFac,
				isFell: row.IsFell
			};
			GetDetailsByYHMX(params).then(res => {
				if (res.data.state == 1) {
					let data = JSON.parse(res.data.data);
					this.form = data
					if(this.form.User.IDCardImageTops2.length>0){
						let arr  = []
						this.form.User.IDCardImageTops2.forEach(item=>{
							arr.push(this.$store.state.imgUrl + item.Id)
						})
						this.form.User.IDCardTops = arr
						
					}
					if(this.form.User.IDCardImageAfters2.length>0){
						let arr2 = []
						this.form.User.IDCardImageAfters2.forEach(item=>{
							arr2.push(this.$store.state.imgUrl + item.Id)
						})
						this.form.User.IDCardAfters = arr2
					}
				}
			});
			this.dialogVisible = true
		},
		// 关闭设计公司弹窗
		handleClose() {
			this.designCompanyDialog = false
			this.designCompanyFrom = {}
		},
		// 新增设计公司
		addDesignCompany() {
			this.$refs['designCompanyFrom'].validate(async valid => {
				if (valid) {
					AddCompany(this.designCompanyFrom).then(res => {
						if(res.data.state == 1){
							this.$message('添加成功')
							this.handleClose()
							this.getList()
						}
					})
				}
			})	
		},	
		/* 通过ID删除单行数据 */
		deleteRowData(row) {
		this.$confirm('确定删除？', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(() => {
			DeleteUser(row.UserCode).then(res=>{
			if(res.data.state==1){
				this.$message.success('操作成功')
				this.getList()
			}else{
					this.$message.erroe(res.data.msg)
				}
			})
		}).catch(()=>{})
		},
	}
};
</script>
<style lang="less" scoped>
.user {
	height: 100%;
  .search {
    padding: 15px;
  	display: flex;
		justify-content: space-between;
  	align-items: center;
  	.title {
  		font-size: 20px;
  		font-weight: bold;
  	}
  	.condition {
  		display: flex;
  		align-items: center;
  		margin-right: 20px;
  	}
  }
	.table {
		padding: 0px 15px;
	}
	.page {
		text-align: center;
	}
	/deep/ .el-dialog__header {
		padding: 10px;
		background-color: #5bacf0;
	}
	/deep/ .el-dialog__title {
		color: #fff;
	}
	/deep/ .el-dialog__body {
		padding: 15px;
	}
	/deep/ .el-dialog__footer {
		padding: 0px 10px 10px 10px;
	}
	/deep/ .el-dialog__headerbtn .el-dialog__close {
		color:#fff!important;
	}
	.el-form-item {
		margin-bottom: 22px;
	}
}
</style>
